import React from 'react';
import { CtaButton } from './CtaButton';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 bg-brand-purpleLight" data-id="element-97">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-98">
        <div className="flex flex-col gap-6 text-center md:text-left order-2 md:order-1" data-id="element-99">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-darkGray leading-tight" data-id="element-100">
            Tu air fryer lleva meses guardada.{' '}
            <span className="italic text-brand-purple" data-id="element-101">Hoy eso cambia.</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-mediumGray font-medium leading-relaxed" data-id="element-102">
            Más de 30 recetas listas en menos de 20 minutos. Sin saber cocinar.
            Sin ingredientes raros. Sin complicarte la vida.
          </p>

          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-4 gap-y-2 text-sm text-brand-purpleDark font-medium mt-2" data-id="element-103">
            <div className="flex items-center gap-1.5" data-id="element-104">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-105" />
              <span data-id="element-106">Acceso inmediato</span>
            </div>
            <span className="hidden sm:inline text-brand-purple/30" data-id="element-107">·</span>
            <div className="flex items-center gap-1.5" data-id="element-108">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-109" />
              <span data-id="element-110">Funciona con cualquier marca</span>
            </div>
            <span className="hidden sm:inline text-brand-purple/30" data-id="element-111">·</span>
            <div className="flex items-center gap-1.5" data-id="element-112">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-113" />
              <span data-id="element-114">Garantía de 5 días</span>
            </div>
          </div>

          <div className="mt-6 flex flex-col items-center md:items-start gap-3" data-id="element-115">
            <CtaButton text="→ Quiero mis recetas ahora" size="xl" className="w-full" data-id="element-116" />
            <p className="text-sm text-brand-mediumGray text-center md:text-left" data-id="element-117">
              Descarga instantánea en PDF — lo abrís desde el celu en segundos
            </p>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-md md:max-w-full order-1 md:order-2" data-id="element-118">
          <img src="https://cdn.magicpatterns.com/uploads/gvNRSBs7CPvvhShmiBmZAh/AC358B5D-8A9E-4683-8767-26B49CF693EA.png" alt="Recetas en Air Fryer" className="w-full h-auto drop-shadow-2xl" data-id="element-119" />
        </div>
      </div>
    </section>;
}